import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=2c23df7e&scoped=true"
var script = {}
import style0 from "./CheckList.vue?vue&type=style&index=0&id=2c23df7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23df7e",
  null
  
)

export default component.exports